/* eslint-disable no-unused-expressions */
/* eslint-disable react/prop-types */
import { resellerApiWithToken } from '@api/baseApi'
import SelectFromApi from '@components/CustomFields/SelectFromApi'
import useAxios from '@hooks/useAxios'
import React, { useEffect } from 'react'
import { useFormContext } from 'react-hook-form'
import FieldText from '@components/CustomFields/FieldText'

const FormComponent = ({
  defaultValues, disabled, scope, max,
}) => {
  const {
    register,
    setValue,
    getValues,
    unregister,
    control,
    errors,
    watch,
  } = useFormContext()

  const formProps = {
    register,
    setValue,
    getValues,
    unregister,
    control,
    defaultValues,
    disabled,
    errors,
    watch,
  }

  let path

  if (scope === 'reseller') {
    path = '/resellers/bank_accounts'
  } else {
    path = '/affiliates/bank_accounts'
  }

  const { fetch, data, isFetching } = useAxios(resellerApiWithToken, 'get', path)

  useEffect(() => {
    fetch()
  }, [])

  const values = getValues()
  useEffect(() => {
    if (values?.amount >= max && max > 0) {
      setValue('amount', max)
    } else if (values?.amount >= max && max < 0) {
      setValue('amount', 0)
    }
  }, [values?.amount, max])
  return (
    <div>
      <SelectFromApi
        name="bank"
        label="Bank"
        placeholder="Cari Bank..."
        register={register}
        setValue={setValue}
        defaultValues={defaultValues}
        errors={errors}
        control={control}
        loading={isFetching}
        getOptionSelected={(value) => value.id}
        getOptionLabel={(value) => `${value.bank_name} - ${value.name} - ${value.number}`}
        // getOptionLabel={(value) => value.number}
        options={data || []}
        // {...props}
      />
      <FieldText
        name="amount"
        label="Amount"
        type="number"
        inputProps={{ min: 0, max }}
        {...formProps}
      />
    </div>
  )
}
export default FormComponent
